import { Theme } from '@mui/material/styles/createTheme';
import { portalPaths } from '@provision/portal-routes';
import { ActivityMessage } from 'src/components/ActivityList/activity-list-item';
import { ActivityRefChip } from 'src/components/ActivityList/activity-ref-chip';
import { DynamicIcon } from 'src/components/DynamicIcon/dynamic-icon';
import { ActivityFeed } from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';

export const buildProjectMessage = (activity: ActivityFeed): ActivityMessage[] => {
  const actorName = activity.actor?.name?.trim() || '<Platform User>';

  switch (activity.activityType) {
    case 'create': {
      const projectId = activity.changes.find((change) => change.field === 'id')?.value!;
      const projectName = activity.changes.find((change) => change.field === 'name')?.value!;
      return [
        {
          id: activity.id,
          icon: 'sparkle',
          iconLibrary: 'lucide',
          color: (theme: Theme) => theme.palette.custom.OV.sys.primary,
          message: (
            <>
              {actorName} created{' '}
              <ActivityRefChip
                label={projectName}
                icon={<DynamicIcon name="folder-open" library="lucide" />}
                iconColor={(theme) => theme.palette.custom.OV.sys.tertiary}
                clickable
                path={portalPaths.entity.selected('project', 'all', projectId)}
              />
            </>
          ),
          timestamp: activity.timestamp,
        },
      ];
    }
    case 'delete':
      return [
        {
          id: activity.id,
          icon: 'trash-2',
          iconLibrary: 'lucide',
          color: (theme: Theme) => theme.palette.custom.OV.sys.primary,
          message: `${actorName} deleted the project`,
          timestamp: activity.timestamp,
        },
      ];
    case 'update': {
      const isRestore = activity.changes.some(
        ({ field, value, previousValue }) =>
          field === 'deletedAt' && !value && !!previousValue,
      );
      if (!isRestore) {
        return [];
      }
      return [
        {
          id: activity.id,
          icon: 'undo-2',
          iconLibrary: 'lucide',
          color: (theme: Theme) => theme.palette.custom.OV.sys.primary,
          message: `${actorName} restored the project`,
          timestamp: activity.timestamp,
        },
      ];
    }
    default:
      return [];
  }
};
